var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tournament-list-wrap"},_vm._l((_vm.matchList),function(match,matchIndex){return _c('FixtureDetailMatchContent',{key:("match " + matchIndex),attrs:{"match":match,"tournament":_vm.tournament}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }